import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaShieldAlt, FaTags, FaCamera, FaSyncAlt, FaFileInvoice, FaLayerGroup } from "react-icons/fa";
import FeatureImage from "../assets/FeaturesSection.png";

const features = [
  {
    icon: <FaShieldAlt size={40} color="#ffffff" />,
    italic: "Bank-Level Security",
    title: "Your privacy is our top priority.",
    subtitle:
      "Every transaction is safeguarded with bank-grade encryption, ensuring your sensitive information stays 100% secure.",
    secondary: "We never store or share your data — your finances remain truly yours.",
  },
  {
    icon: <FaTags size={40} color="#ffffff" />,
    italic: "Auto Categorization",
    title: "Smarter tracking. Less effort.",
    subtitle:
      "Our intelligent system automatically tags, groups, and classifies every expense — from coffee runs to client invoices — so you don’t have to.",
    secondary: "Spend less time sorting and more time growing your business.",
  },
  {
    icon: <FaCamera size={40} color="#ffffff" />,
    italic: "Smart Receipt Scan",
    title: "Snap. Scan. Sorted.",
    subtitle:
      "Just take a photo of any receipt, and our AI instantly extracts details like amount, date, and category.",
    secondary: "No manual entry. No clutter. Just clean, accurate logs in seconds.",
  },
  {
    icon: <FaSyncAlt size={40} color="#ffffff" />,
    italic: "Real-Time Sync",
    title: "Always up-to-date. Instantly.",
    subtitle:
      "Your dashboard refreshes automatically with real-time updates from your linked accounts.",
    secondary: "No refresh needed — your numbers are always current, everywhere you go.",
  },
  {
    icon: <FaFileInvoice size={40} color="#ffffff" />,
    italic: "IRS-Compliant Docs",
    title: "Reports ready when you are.",
    subtitle:
      "Generate tax-ready summaries and detailed reports in one click.",
    secondary: "Stay compliant with IRS and CPA standards — because clarity shouldn’t come with stress.",
  },
  {
    icon: <FaLayerGroup size={40} color="#ffffff" />,
    italic: "Multi Business Account Support",
    title: "Switch between the businesses with one tap.",
    subtitle:
      "Easily manage multiple business profiles from a single account.",
    secondary:
      "Switch between entities effortlessly and keep every transaction organized under one secure hub.",
  },
];

const FeaturesSection = () => {
  return (
    <section className="features-section">
      <Container fluid className="px-md-5 h-100">

        <motion.div
            className="mb-5 text-center text-center w-100"
            initial={{ opacity: 0, y: -30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
        >
            <h2 className="display-5 fw-bold mb-3">
            Smarter features for simpler taxes.
            </h2>
            <p className="fs-5 text-light opacity-75">
            Three simple steps to smarter tax savings.
            </p>
        </motion.div>

        <Row className="h-100 mt-5">
          {/* LEFT IMAGE (sticky) */}
          <Col md={5} className="text-center p-0">
            <div className="sticky-image-wrapper">
              <motion.img
                src={FeatureImage}
                alt="Features"
                className="img-fluid rounded-4 shadow-lg features-img"
                initial={{ opacity: 0, x: -60 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              />
            </div>
          </Col>

          {/* RIGHT SCROLLABLE CONTENT */}
          <Col md={7} className="text-white d-flex flex-column justify-content-start">
            {/* This scrolls independently */}
            <div className="features-scroll-container">
              {features.map((item, index) => (
                <motion.div
                  key={index}
                  className="feature-item mb-5 pb-4"
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <div className="mb-3 d-flex align-items-center">
                    <span>{item.icon}</span>
                    <em className="ms-3 text-secondary d-block fs-3">{item.italic}</em>
                  </div>
                  <h4 className="fw-bold mt-2">{item.title}</h4>
                  <p className="text-light mt-2">{item.subtitle}</p>
                  <p className="text-secondary fw-semibold">{item.secondary}</p>
                </motion.div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FeaturesSection;
